import CatalogTile from './CatalogTile.vue';

export { CatalogTile };
export default CatalogTile;
